import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { DATE_FORMAT } from 'framework/utils';
import { FC } from 'react';
import { FieldProps, useFieldHelper, TextFieldWithPrefix } from 'framework/ui/field';
import { FactDateIcon, Tooltip } from 'framework/ui/mui-builder';

interface FactDateFieldProps extends FieldProps {
  plannedDateSource: string;
  isLinkedCRSource?: string;
}

const FactDateField: FC<FactDateFieldProps> = props => {
  const { plannedDateSource, isLinkedCRSource } = props;
  const { getValue } = useFieldHelper<string>(props);
  const { getValue: getValuePlannedDate } = useFieldHelper<string>({ source: plannedDateSource });
  const { getValue: getIsLinkedCR } = useFieldHelper<boolean>({ source: isLinkedCRSource || '' });

  const plannedDate = getValuePlannedDate();
  const factDate = getValue();
  const isLinkedCR = getIsLinkedCR();

  let delayDays: number | null = null;
  if (plannedDate && factDate) {
    const planned = moment(plannedDate, DATE_FORMAT.API_ONLY_DATE);
    const actual = moment(factDate, DATE_FORMAT.API_ONLY_DATE);

    if (actual.isAfter(planned)) {
      delayDays = actual.diff(planned, 'days');
    }
  }
  const hasDelay = delayDays !== null && delayDays > 0 && !isLinkedCR;

  const textField = (
    <TextFieldWithPrefix
      tooltipProps={{
        title: 'Fact date',
        children: (
          <div>
            <FactDateIcon />
          </div>
        ),
      }}
      label=""
      value={
        hasDelay ? (
          <Tooltip title={`overdue ${delayDays} d`}>
            <span>
              <Typography color="error" component="span">
                {factDate}
              </Typography>
            </span>
          </Tooltip>
        ) : (
          factDate
        )
      }
    />
  );

  return (
    <Box gap={2} display="flex">
      {textField}
    </Box>
  );
};

export default FactDateField;
